import { useContext, useEffect, useState } from "react";
import { FormControlLabel, Grid, IconButton, Paper } from "@mui/material";
import { MoreVert as MoreVertIcon } from "@mui/icons-material"
import { Box, Container } from "@mui/system";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { getAll, updateActive } from "./services/api";
import { SnackbarGlobal } from "components/Snackbar";
import { Android12Switch, StyledMenu } from "components/Styled";
import { FMPageOpacityTransition } from "components/FMTransitions/PageTransitions";
import { BranchOfficeCard } from "./components/BranchOfficeCard";
import { ActionFabButtonAdd, ActionsDialogPage, ActionsMenuPage } from "./ActionsPage";
import { TableSearch } from "components/Table";
import { AuthContext } from "context/AuthContext";

export default function BranchOffice() {
  const { t } = useTranslation();
  const { setUdateBranchOfficeSelected } = useContext(AuthContext)
  const [dataFilter, setDataFilter] = useState(null)
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete
  const [notification, setNotification] = useState({ open: false, message: "", severity: "" })
  const [instanceSelected, setInstanceSelected] = useState({})
  const queryClient = useQueryClient()
  const { data } = useQuery('branchOfficesList', getAll, { refetchOnWindowFocus: false })

  useEffect(() => {
    if (data !== undefined && data !== null && data !== "") setDataFilter(data.data)
  }, [data])

  const mutation = useMutation(updateActive, {
    onSuccess: (data) => {
      if (data.status === "error") { handleWatchAction(false, 'Error al guardar los datos', 'error') }
      else { 
        setUdateBranchOfficeSelected(new Date())
        handleRefreshData(); handleWatchAction(true, 'Acción realizada correctamente', 'success') 
      }
    }
  })

  const handleUpdateActive = (item) => mutation.mutate({ id: item._id, params: { active: !item.active } })

  const handleRefreshData = () => { queryClient.invalidateQueries('branchOfficesList') }
  const handleResetActions = () => { setOpenAction(0) }
  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { handleResetActions(); handleRefreshData() }
  }

  const handleSearch = (e) => {
    const dataFilter = data.data.filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase(), 0))
    setDataFilter(dataFilter)
  }

  const [anchorElMenuActions, setAnchorElMenuActions] = useState(null)
  const open = Boolean(anchorElMenuActions)
  const handleClickMenuActions = (event, item) => { setAnchorElMenuActions(event.currentTarget); setInstanceSelected(item) }
  const handleCloseMenuActions = () => { setAnchorElMenuActions(null) }

  const handleMenuItemClick = (option) => { setOpenAction(option); handleCloseMenuActions(); }

  return (<>
    <FMPageOpacityTransition>
      <Box component="main" style={{ marginBottom: 100 }}>
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          {(dataFilter !== null) && <>
            <Paper sx={{ padding: 3, marginBottom: 2 }}>
              <TableSearch
                placeholder={t("branchoffice_search_placeholder_text")}
                searchAction={handleSearch}
              />
            </Paper>
            {dataFilter.map((item, index) => (
              <Grid key={`${index}-${item._id}`} container spacing={12}>
                <Grid item xs={12}>
                  <Paper sx={{ padding: 3, marginBottom: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div style={{ textAlign: "end" }}>
                          <FormControlLabel
                            control={
                              <Android12Switch
                                checked={item.active}
                                onClick={() => handleUpdateActive(item)} />
                            } />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <BranchOfficeCard
                          t={t}
                          item={item}
                          actions={<>
                            <IconButton
                              id={`demo-customized-button-${item._id}`}
                              aria-controls={open ? `demo-customized-menu-${item._id}` : undefined}
                              aria-haspopup="true"
                              aria-expanded={open ? 'true' : undefined}
                              variant="contained"
                              onClick={(event) => handleClickMenuActions(event, item)}
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <StyledMenu
                              id={`demo-customized-menu-${item._id}`}
                              MenuListProps={{ 'aria-labelledby': `demo-customized-button-${item._id}` }}
                              anchorEl={anchorElMenuActions}
                              open={open}
                              onClose={handleCloseMenuActions}
                            >
                              <ActionsMenuPage t={t} action={handleMenuItemClick} />
                            </StyledMenu>
                          </>} />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            ))}
          </>}
        </Container>
      </Box>
      <ActionFabButtonAdd t={t} action={() => setOpenAction(1)} />
      <ActionsDialogPage
        open={openAction}
        close={() => handleResetActions()}
        instance={instanceSelected}
        reportAction={handleWatchAction} />
    </FMPageOpacityTransition>
    <SnackbarGlobal
      open={notification.open}
      close={() => setNotification({ open: false, message: "", severity: "" })}
      message={notification.message}
      severity={notification.severity} />
  </>)
}